<div class="user-stats__table__header">
  <div
    *ngFor="let cell of cells; last as isLast"
    class="slot"
    [class.slot--small]="isLast"
    [ngClass]="{
      'slot--slot-align-left': slotAlignment[0],
      'slot--slot-align-right': slotAlignment[2]
    }">
    <div class="slot__content" *ngIf="cell.icon !== null || cell.label !== null">
      <span *ngIf="cell.icon !== null" class="odilo-icon">{{ cell.icon }}</span>
      <p *ngIf="cell.label !== null">{{ cell.label | translateByCustomerType: customerType.dbValue }}</p>
    </div>
  </div>
</div>
